import React from 'react';

export default function GalleryImage({ image, ...props }) {
  return (
    <button
      type="button"
      name="Gallery Image"
      aria-label="Gallery Image"
      className="gallery-image-wrapper"
    >
      <img
        className="gallery-image lazyload"
        data-src={image.small_image_url || image.large_image_url}
        alt=""
        title=""
        {...props}
      />
    </button>
  );
}
